import * as React from 'react';
import MuiPopover, { PopoverProps as MuiPopoverProps } from '@mui/material/Popover';

export type PopoverProps = MuiPopoverProps;

const Popover: React.FunctionComponent<React.PropsWithChildren<PopoverProps>> = ({
  children,
  ...props
}) => {
  return <MuiPopover {...props}>{children}</MuiPopover>;
};

export default Popover;
